import { observer } from 'mobx-react-lite';
import PhishingTemplateManager from 'PhishingTemplateManager';
import styles from './styles/PhishingTemplateManager.module.scss';

function PhishingTemplate() {
    const isTemplateRoute = window.location.pathname.includes('/phishing-manager/templates');

    return (
        <div className={styles.phishingTemplateLayout}>
            {isTemplateRoute && <PhishingTemplateManager />}
        </div>
    );
}

export default observer(PhishingTemplate);